import styled from "styled-components";

export const BulkProgramDownloadTemplateWrapper = styled.div`
  .warning-badge {
    margin: 16px 0px 0px;
    display: flex;
    align-items: flex-start;

    svg {
      width: 34px;
      height: 30px;
      margin-right: 14px;
    }
  }
`;
